var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-sheet',{attrs:{"inset":_vm.viewport.md,"scrollable":_vm.scrollable},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('v-sheet',{staticClass:"mobile-padding",on:{"click":function($event){_vm.persistent ? null : (_vm.open = false)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }